import React, { useContext } from "react"
import AdminProyecto from "./AdminProyecto"
import { AppContext } from "./index"

export default function NuevoProyecto() {
    let { firebase } = useContext(AppContext)

    firebase.activarProyecto()
    return (
        <AdminProyecto f={"Datos Generales"} />
    )
}